<template>
  <div class="score-management-page">
    <!-- 頂部標題區域 -->
    <div class="page-header">
      <div class="header-content">
        <div class="header-icon">📊</div>
        <div class="header-text">
          <h1 class="page-title">我的學分查詢</h1>
          <p class="page-subtitle">查詢並管理您的年度學分獲得記錄</p>
        </div>
      </div>
    </div>

    <!-- 年份選擇器區域 -->
    <div class="year-selector-section">
      <div class="selector-container">
        <div class="selector-card">
          <div class="selector-header">
            <div class="selector-icon">📅</div>
            <div class="selector-title">
              <h3>選擇查詢年份</h3>
              <p>請選擇要查看學分記錄的年份</p>
            </div>
          </div>
          
          <div class="datepicker-wrapper">
            <vuejs-datepicker 
              :value="this.defaultDate"
              :format="DatePickerFormat"
              :language="language"
              :bootstrap-styling="true"
              v-model="yDate"
              @selected="doYDate"
              minimum-view="year"
            ></vuejs-datepicker>
            
            <div class="current-year-display">
              <span class="year-label">當前查詢年份：</span>
              <span class="year-value">{{ setDates(yDate) }} 年</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 學分詳情區域 -->
    <div class="score-details-section">
      <b-tabs v-model="activeTab" @input="onTabChange" content-class="mt-3" class="custom-tabs">
        <b-tab key="score" title="活動成績查詢">
          <div>
            <Actscore :useid="useid" :yDate="setDates(yDate)" ref="con2"/>
          </div>
        </b-tab>
        <b-tab key="other" title="其它得分查詢">
          <div class="other-query-section">
            <!-- 區塊標題列 -->
            <div class="other-query-header">
              <div class="other-header-left">
                <span class="other-header-icon">📋</span>
                <div>
                  <h3 class="other-title">其它點數得分紀錄</h3>
                  <p class="other-subtitle">查看您的得分明細</p>
                </div>
              </div>
              <div class="amount-sum-badge">
                <span class="amount-sum-label">量測總分</span>
                <span class="amount-sum-value">{{ amountSum }}</span>
                <span class="amount-sum-unit">點</span>
              </div>
            </div>

            <!-- 表格內容 -->
            <div class="other-table-wrapper">
              <a-table v-if="Array.isArray(myData) && myData.length > 0"
                :columns="columns"
                :row-key="record => record.id"
                :data-source="myData"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
                bordered
              >    
                <template slot="card" slot-scope="record">
                  <div class="transaction-card">
                    <div class="transaction-card-top">
                      <span class="tx-type-tag" :class="record.amount > 0 ? 'tag-earn' : 'tag-spend'">
                        {{ record.amount > 0 ? '獲得' : '扣除' }}
                      </span>
                      <span class="tx-amount" :class="record.amount > 0 ? 'amt-pos' : 'amt-neg'">
                        {{ record.amount > 0 ? '+' : '' }}{{ record.amount }}
                        <small class="tx-unit">點</small>
                      </span>
                    </div>
                    <div class="transaction-card-body">
                      <div class="tx-grid">
                        <div class="tx-item">
                          <span class="tx-icon">👤</span>
                          <span class="tx-label">發放單位</span>
                          <span class="tx-val">雲林縣活動平台</span>
                        </div>
                        <div class="tx-item">
                          <span class="tx-icon">👤</span>
                          <span class="tx-label">獲得點數</span>
                          <span class="tx-val">{{ record.udisplayname }}</span>
                        </div>
                      </div>
                      <div class="tx-detail-row" v-if="record.detail">
                        <span class="tx-icon">📝</span>
                        <span class="tx-label">得分說明</span>
                        <span class="tx-val tx-detail-text">{{ record.detail }}</span>
                      </div>
                      <div class="tx-time-row">
                        <span class="tx-icon">🕐</span>
                        <span class="tx-time">{{ fdateformat(record.created_at) }}</span>
                      </div>
                    </div>
                  </div>
                </template>                   
              </a-table>
              <div v-else-if="!loading" class="empty-data-section">
                <div class="empty-icon">📭</div>
                <p class="empty-text">目前沒有查詢資料</p>
                <p class="empty-hint">請嘗試選擇其他年份查詢</p>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import * as moment from "moment/moment";
import Actscore from './panel/Actscore.vue'
import vuejsDatepicker from 'vuejs-datepicker';
import { joinService } from '../_services'
import 'moment/locale/zh-tw';

const queryData = params => {
  return joinService.findMyPersonalScore(params) 
}; 

const queryTotalScore = params => {
  return joinService.findMyPersonalTotalScore(params) 
};

const columns = [
  {
    title: '',
    dataIndex: '',
    scopedSlots: { customRender: 'card' }
  }
];

export default {
  name: 'Mymailscore',
  components: {
    Actscore,
    vuejsDatepicker,
  }, 
  props: {
    msg: String
  },
  data() {
    const now = new Date()
    const today = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate())).format("YYYY-MM-DD") 
    return {  
      useid:0,
      activeTab: 0,
      defaultDate: today ,
      DatePickerFormat: 'yyyy',
      yDate: moment(today).format("YYYY"),
      pagination: {defaultPageSize:4},
      myTotalScore:0,
      amountSum:0,
      myData:[],
      loading: false,
      columns,
      language:{
        language: 'Chinese', 
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], 
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], 
        days: ['日', '月', '火', '水', '木', '金', '土'], 
        rtl: false, 
        ymd: false, 
        yearSuffix: '年'
      }        
    };
  }, 
  computed: {
    ...mapState("account", ["status", "user","linecheck"]),
  },   
  mounted(){
        if(this.user!==null){  
          this.useid = this.user.data.user.id 
          const now = new Date()
          const today = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate())).format("YYYY-MM-DD") 
          this.yDate = moment(today).format("YYYY") 
          this.showDATA();
          this.reload();
          //this.getScore();
        }
  },
  methods: {
    doYDate(date) {
       this.yDate=moment(date).format("YYYY");
       this.showDATA();
       this.reload();
       //this.getScore();
    },    
    changedYear(e){
        console.log(e)
    },            

    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },
    showDATA(){
      setTimeout(() => {
        this.$refs["con2"].fetch();  
      }, 500);                 

    },
    setDates(val){
        return moment(val).format("YYYY");
    },

    reload(){
      this.fetch({results:4,page:1,pageSize: 4,uid:parseInt(this.user.data.user.id),
        yDate: this.yDate
      });
    },

    handleTableChange(pagination, filters, sorter) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            sortField: sorter.field,
            sortOrder: sorter.order,
            uid: parseInt(this.user.data.user.id),
            yDate: this.yDate,
            ...filters,
        });
    },
    fetch(params = {}) {
      this.loading = true;
      queryData({
          ...params,
      }).then(({ data }) => {
          const pagination = { ...this.pagination };
          pagination.total = data.info.totail;
          this.amountSum = data.amount_sum;
          this.loading = false;
          this.myData = data.results;
          this.pagination = pagination;
      });
    },

    getScore() {
      var params = {uid:parseInt(this.user.data.user.id)}
      queryTotalScore({
          ...params,
      }).then(({ data }) => {
          this.myTotalScore = data;
      });
    },

    coverNameType(type) {
      if (type === 'earning') return '增加';
      if (type === 'spending') return '扣除';
      return '';
    },

    onTabChange(tabIndex) {
      if (tabIndex === 0) {
        this.$nextTick(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    },
    coverNameAction(action) {
      if (action === 1 || action === '1') return '購物紅利';
      if (action === 2 || action === '2') return '表現優異';
      if (action === 3 || action === '3') return '其它';
      if (action === 4 || action === '4') return '移轉點數';
      if (action === 5 || action === '5') return '未綁定LINE帳號交易';
      return '';
    },
  },      
}
</script>
<style scoped>
/* 主容器樣式 */
.score-management-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 20px;
}

/* 頂部標題區域 */
.page-header {
  margin-bottom: 30px;
}

.header-content {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 25px 35px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 1200px;
  margin: 0 auto;
}

.header-icon {
  font-size: 48px;
  margin-right: 20px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { 
    transform: scale(1); 
    opacity: 1; 
  }
  50% { 
    transform: scale(1.05); 
    opacity: 0.8; 
  }
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #6c757d, #495057);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-subtitle {
  font-size: 16px;
  color: #7f8c8d;
  margin: 5px 0 0 0;
  font-weight: 500;
}

/* 年份選擇器區域 */
.year-selector-section {
  margin-bottom: 30px;
  position: relative;
  z-index: 10;
}

.selector-container {
  max-width: 1200px;
  margin: 0 auto;
}

.selector-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: visible;
  transition: all 0.3s ease;
  position: relative;
}

.selector-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.selector-header {
  display: flex;
  align-items: center;
  padding: 25px 30px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
}

.selector-icon {
  font-size: 32px;
  margin-right: 15px;
}

.selector-title h3 {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 5px 0;
}

.selector-title p {
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
}

/* 日期選擇器包裝器 */
.datepicker-wrapper {
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.custom-datepicker {
  flex: 1;
  max-width: 300px;
}

/* 自定義日期選擇器樣式 */
.custom-datepicker ::v-deep .vdp-datepicker {
  position: relative;
  z-index: 9999;
}

.custom-datepicker ::v-deep .vdp-datepicker__calendar {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  background: white;
  overflow: visible;
  z-index: 10000;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
}

.custom-datepicker ::v-deep .vdp-datepicker__calendar header {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
  padding: 16px;
  border-radius: 0;
  position: relative;
  z-index: 10001;
}

.custom-datepicker ::v-deep .vdp-datepicker__calendar .cell {
  z-index: 10001;
}

.custom-datepicker ::v-deep .vdp-datepicker__calendar .cell:hover {
  background-color: rgba(108, 117, 125, 0.1);
}

.custom-datepicker ::v-deep .vdp-datepicker__calendar .cell.selected {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
}

.custom-datepicker ::v-deep input {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  background: white;
  transition: all 0.3s ease;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 9998;
}

.custom-datepicker ::v-deep input:focus {
  border-color: #6c757d;
  box-shadow: 0 4px 16px rgba(108, 117, 125, 0.2);
  outline: none;
}

.custom-datepicker ::v-deep input::placeholder {
  color: #adb5bd;
}

/* 當前年份顯示 */
.current-year-display {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 16px 24px;
  border-radius: 12px;
  border: 2px solid #dee2e6;
  flex-shrink: 0;
}

.year-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  margin-right: 8px;
}

.year-value {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  background: linear-gradient(135deg, #6c757d, #495057);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 學分詳情區域 */
.score-details-section {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* 可用點數區域 */
.total-score-section {
  margin-bottom: 20px;
}

.total-score-container {
  max-width: 1200px;
  margin: 0 auto;
}

.total-score-alert ::v-deep .ant-alert-message {
  font-size: 16px;
  font-weight: 700;
}

/* 隱藏 ant-table 表頭 */
::v-deep .ant-table-thead {
  display: none !important;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .score-management-page {
    padding: 15px;
  }
  
  .header-content {
    padding: 20px;
    flex-direction: column;
    text-align: center;
  }
  
  .header-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .page-subtitle {
    font-size: 14px;
  }
  
  .selector-header {
    padding: 20px;
    flex-direction: column;
    text-align: center;
  }
  
  .selector-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .datepicker-wrapper {
    padding: 20px;
    flex-direction: column;
    align-items: stretch;
  }
  
  .custom-datepicker {
    max-width: none;
  }
  
  .current-year-display {
    justify-content: center;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .score-management-page {
    padding: 10px;
  }
  
  .header-content {
    padding: 15px;
  }
  
  .page-title {
    font-size: 22px;
  }
  
  .selector-header {
    padding: 15px;
  }
  
  .datepicker-wrapper {
    padding: 15px;
  }
  
  .current-year-display {
    padding: 12px 20px;
    flex-direction: column;
    text-align: center;
    gap: 5px;
  }
}

/* 載入動畫 */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.selector-card {
  animation: slideInUp 0.6s ease-out;
}

.score-details-section {
  animation: slideInUp 0.8s ease-out;
}

/* Tabs 樣式 */
.custom-tabs ::v-deep .nav-tabs {
  border-bottom: 2px solid #dee2e6;
  margin-bottom: 0;
}

.custom-tabs ::v-deep .nav-tabs .nav-link {
  font-size: 16px;
  font-weight: 600;
  color: #6c757d;
  padding: 12px 24px;
  border: none;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}

.custom-tabs ::v-deep .nav-tabs .nav-link:hover {
  color: #495057;
  border-bottom-color: #adb5bd;
}

.custom-tabs ::v-deep .nav-tabs .nav-link.active {
  color: #495057;
  background: transparent;
  border-bottom-color: #495057;
}

/* 其它查詢區塊樣式 */
.other-query-section {
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 0;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

/* 標題列 */
.other-query-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 22px 28px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 1px solid #eaedf0;
}

.other-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.other-header-icon {
  font-size: 30px;
}

.other-title {
  font-size: 19px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 2px 0;
}

.other-subtitle {
  font-size: 13px;
  color: #95a5a6;
  margin: 0;
}

/* 總得分徽章 */
.amount-sum-badge {
  display: flex;
  align-items: baseline;
  gap: 6px;
  background: linear-gradient(135deg, #f1f3f5, #e9ecef);
  padding: 10px 20px;
  border-radius: 12px;
  border: 1.5px solid #dee2e6;
}

.amount-sum-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

.amount-sum-value {
  font-size: 24px;
  font-weight: 800;
  color: #2c3e50;
  line-height: 1;
}

.amount-sum-unit {
  font-size: 14px;
  color: #6c757d;
  font-weight: 600;
}

/* 表格區 */
.other-table-wrapper {
  padding: 20px 24px 24px;
}

/* 交易卡片 */
.transaction-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 14px;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

.transaction-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.07);
  transform: translateY(-1px);
}

.transaction-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: linear-gradient(135deg, #f8f9fa, #f1f3f5);
  border-bottom: 1px solid #eaedf0;
}

.tx-type-tag {
  display: inline-block;
  padding: 3px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.tx-type-tag.tag-earn {
  background: #d4edda;
  color: #155724;
}

.tx-type-tag.tag-spend {
  background: #f8d7da;
  color: #721c24;
}

.tx-amount {
  font-size: 22px;
  font-weight: 800;
}

.tx-amount.amt-pos {
  color: #28a745;
}

.tx-amount.amt-neg {
  color: #dc3545;
}

.tx-unit {
  font-size: 13px;
  font-weight: 600;
  margin-left: 2px;
  opacity: 0.7;
}

.transaction-card-body {
  padding: 16px 20px;
}

.tx-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.tx-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.tx-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.tx-label {
  font-size: 12px;
  color: #95a5a6;
  font-weight: 500;
  white-space: nowrap;
  min-width: 48px;
}

.tx-val {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tx-detail-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 10px 0;
  border-top: 1px dashed #e9ecef;
  margin-bottom: 6px;
}

.tx-detail-text {
  white-space: normal;
  word-break: break-all;
  line-height: 1.6;
}

.tx-time-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid #f1f3f5;
}

.tx-time {
  font-size: 12px;
  color: #adb5bd;
  font-weight: 500;
}

/* 空資料 */
.empty-data-section {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 14px;
  opacity: 0.6;
}

.empty-text {
  font-size: 17px;
  color: #6c757d;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.empty-hint {
  font-size: 14px;
  color: #adb5bd;
  margin: 0;
}

@media (max-width: 768px) {
  .other-query-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 18px 20px;
  }

  .amount-sum-badge {
    align-self: stretch;
    justify-content: center;
  }

  .tx-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .tx-amount {
    font-size: 18px;
  }

  .other-table-wrapper {
    padding: 14px;
  }

  .custom-tabs ::v-deep .nav-tabs .nav-link {
    font-size: 14px;
    padding: 10px 16px;
  }
}
</style>

